const state = {
  report: [],
  report_id: [],
  customer_list_id: [],
  reason: [],
};

export default state;
